import React from 'react'
import { useStaticQuery, graphql } from "gatsby"
import Form from "../components/form"

const SOLICITOR_ROLES = /lawyer|solicitor|counsel|associate|director/i

const Banner = ({title, mobileTitle}) =>{
    const { team: { nodes } } = useStaticQuery(graphql`
        query {
            team: allDatoCmsTeamMember(sort: {fields: position, order: ASC}) {
                nodes {
                    name
                    companyPosition
                }
            }
        }
    `)
    const solicitors = nodes
        .filter(({ companyPosition }) => SOLICITOR_ROLES.test(companyPosition || ""))
        .map(({ name }) => name.trim())

    return(
        <>  
            <p className="h3 m0 mt20 m-p20 m-m0 m-show">{mobileTitle}</p>
            <p className="h3 m0 max-350 mb40 m-p20 t-pl20 m-m0 m-hide">{title}</p>
            <Form solicitors={solicitors} />
        </>
    )
}
export default Banner
